import thunk from 'redux-thunk';
import {
  attendeeRosterLocalStoragePersister,
  api as apiMiddleware,
  broadcastSocketMiddleware,
  clearAttendeeRosterLocalStorage,
  notifyDirectors,
  programEmitter,
  programSceneLayerUpdater,
  updateProgramByCameraStatus,
  sessionStateEmitter,
  attendeeRosterEmitter,
  rejectedKnockMiddleware,
  redirectIfLoggedOut,
  streamRecordStatus,
  updateSourceChangesToProgram,
  notification,
  dataDog as dataDogMiddleware,
  showAPIError,
  updateProgramLayers,
  presentationControlNotifier,
  sourceUpdateStatusManager,
  setSourceInitializing,
  actionDebugger,
  updateAttendeeCameraStatus,
  videoPriorityBasedPolicyMiddleware,
  chimeMetricsOnstageAttendeeUpdaterMiddleware,
  toggleBackgroundHiddenMiddleware,
} from '@shoflo/studio-redux/middleware';
import { getEnvVar } from '@shoflo/polymer';
import { createBrowserHistory } from 'history';
import { routerMiddleware } from 'connected-react-router';
import { createStore, applyMiddleware, compose } from 'redux';

import {
  acceptedKnockMiddleware,
  bulkAcceptedKnockMiddleware,
  createdBackgroundMiddleware,
  updateBackgroundOnProgramStartMiddleware,
  notifyDirectors as localNotifyDirectors,
  joinMeetingMiddleware,
} from 'middleware';
import resetSources from 'middleware/source/resetSources';
import createRootReducer from 'reducers';
import { setProgram } from 'actions/program';
import SocketDispatcher from './SocketDispatcher';

function createConfiguredStore() {
  const socketDispatcher = new SocketDispatcher();
  const socket = socketDispatcher.connect();

  const history = createBrowserHistory();

  const initialState = {};

  const enhancers = [];

  const middleware = [
    thunk.withExtraArgument(socket),
    routerMiddleware(history),
    apiMiddleware,
    broadcastSocketMiddleware(socket),
    localNotifyDirectors(socket),
    notifyDirectors(socket),
    acceptedKnockMiddleware(socket),
    bulkAcceptedKnockMiddleware(socket),
    programEmitter(socket),
    sessionStateEmitter(socket),
    attendeeRosterEmitter(socket),
    programSceneLayerUpdater(setProgram),
    updateProgramByCameraStatus(setProgram),
    clearAttendeeRosterLocalStorage,
    attendeeRosterLocalStoragePersister,
    createdBackgroundMiddleware(),
    updateProgramLayers(),
    updateBackgroundOnProgramStartMiddleware(),
    rejectedKnockMiddleware(socket),
    redirectIfLoggedOut,
    streamRecordStatus(socket),
    updateSourceChangesToProgram(setProgram),
    resetSources,
    dataDogMiddleware,
    notification,
    showAPIError,
    presentationControlNotifier(),
    sourceUpdateStatusManager(),
    setSourceInitializing,
    videoPriorityBasedPolicyMiddleware,
    chimeMetricsOnstageAttendeeUpdaterMiddleware,
    joinMeetingMiddleware,
    toggleBackgroundHiddenMiddleware(),
    updateAttendeeCameraStatus,
    actionDebugger, // this should be the last middleware
  ];

  if (getEnvVar('NODE_ENV') === 'development') {
    const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;

    if (typeof devToolsExtension === 'function') {
      enhancers.push(devToolsExtension());
    }
  }

  const composedEnhancers = compose(
    applyMiddleware(...middleware),
    ...enhancers
  );

  const store = createStore(
    createRootReducer(history),
    initialState,
    composedEnhancers
  );

  socketDispatcher.bindToStore(store);

  return {
    store,
    history,
  };
}

const { store, history } = createConfiguredStore();

export { store, history };

export { createConfiguredStore };
